import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const EmailSvg = () => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    style={{ fill: "transparent" }}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z'
      stroke='#3f3d56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M22 6L12 13L2 6'
      stroke='#3f3d56'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export const EmailIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={EmailSvg} {...props} />
);
